var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "both-pd-box" },
    [
      _c("div", { staticClass: "frb" }, [
        _c(
          "div",
          {
            staticClass: "fc",
            staticStyle: { "font-weight": "bold", "font-size": "20px" },
          },
          [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "add_btn pointer", on: { click: _vm.onAdd } },
          [_vm._v("添加联盟账号")]
        ),
      ]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt10" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "channelCode", label: "渠道", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.Screening(
                                _vm.optionsData[_vm.platformCode],
                                scope.row.channelCode
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "apiId", label: "联盟ID", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "ext.feePercent",
                  label: "服务费预留比例",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _vm.platformCode === "KS"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "expires",
                      label: "授权状态",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "fc" }, [
                                !scope.row.ext.expires
                                  ? _c("div", [_vm._v("已授权")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.ext.expires
                                  ? _c(
                                      "div",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("已过期")]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "fc" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "fc pointer",
                                    staticStyle: {
                                      width: "80px",
                                      height: "32px",
                                      background: "#70B603",
                                      "border-radius": "4px",
                                      color: "#fff",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.UpdateAuthorization(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              更新授权\n            "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1818770246
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.platformCode === "KS"
                ? _c("el-table-column", {
                    attrs: {
                      prop: "ext.expiresIn",
                      label: "授权到期时间",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.TimeConversion(
                                      scope.row.ext.accessTime,
                                      scope.row.ext.expiresIn
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2094376587
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "enable", label: "账号状态", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.enable ? "启用" : "不启用") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "fc" }, [
                          _c(
                            "div",
                            {
                              staticClass: "fc pointer",
                              staticStyle: {
                                width: "80px",
                                height: "32px",
                                background: "#409eff",
                                "border-radius": "4px",
                                color: "#fff",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onEditor(scope.row)
                                },
                              },
                            },
                            [_vm._v("\n              编辑\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "fc pointer",
                              staticStyle: {
                                "margin-left": "10px",
                                width: "80px",
                                height: "32px",
                                background: "#f56c6c",
                                "border-radius": "4px",
                                color: "#fff",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onDel(scope.row.id)
                                },
                              },
                            },
                            [_vm._v("\n              删除\n            ")]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mt20 page_box",
              staticStyle: { "text-align": "right" },
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.size,
                  layout: "total, prev, pager, next, sizes,jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AllianceSetup", {
        ref: "allianceSetup",
        on: { refresh: _vm.onRefresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }